import lfApi from '@lf/api-client/lfApi';

export async function getSubscriptionAction(doAddChild) {
    try {
        const response = await lfApi.post('/subscription/action', { do_add_child: doAddChild });
        if (response.status === 200) {
            return response.data;
        }
        else {
            console.error('Failed to get subscription action');
        }
    }
    catch (error) {
        console.error('Error getting subscription action:', error);
    }

    return null;
}

export async function switchSubscriptionTier(priceType) {
    try {
        const response = await lfApi.post('/subscription/switch_tier', { price_type: priceType });
        if (response.status === 200) {
            return response.data;
        }
        else {
            console.error('Failed to switch subscription tier');
        }
    }
    catch (error) {
        console.error('Error switching subscription tier:', error);
    }

    return null;
}

export async function getBillingPortalUrl() {
    try {
        const response = await lfApi.post('/subscription/billing_portal');
        if (response.status === 200) {
            return response.data.url;
        }
        else {
            console.error('Failed to get billing portal url');
        }
    }
    catch (error) {
        console.error('Error getting billing portal url:', error);
    }

    return null;
}
